import React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';

interface InfoProps {
    label?: string;
    isCooled: boolean;
    isSingleProduct?: boolean;
}

export const Info = ({ label, isCooled, isSingleProduct }: InfoProps) => (
    <div className="CooledProductsConflictEntry__Info">
        {label && <div className="CooledProductsConflictEntry__Label">{label}</div>}
        {isCooled && isSingleProduct && (
            <div className="CooledProductsConflictEntry__Badge">{getTranslation(keys['modal.cooledProducts.cooledProductBadge'])}</div>
        )}
    </div>
);
